import { render, staticRenderFns } from "./FormSocialSecurityGroup.vue?vue&type=template&id=4598d71a"
import script from "./FormSocialSecurityGroup.vue?vue&type=script&lang=js"
export * from "./FormSocialSecurityGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports